import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomStepsComponent } from './custom-steps.component';
import { RouterLink } from '@angular/router';




@NgModule({
  declarations: [
    CustomStepsComponent
  ],
  imports: [
    CommonModule,
    RouterLink,


  ],
  exports: [
    CustomStepsComponent
  ]
})
export class CustomStepsModule { }
